/* eslint-disable */
/**
 * @deprecated does nothing
 */
export default {
    attach: function () { },
    detach: function () { },
};



//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/es2015/tabHook.js
// module id = 8301
// module chunks = 2